import { AuthUser } from "@/requests/gen/react-query/fastAPI.schemas";
import { LinkProps } from "@tanstack/react-router";

export function getRedirectPath(user: AuthUser | null): LinkProps["to"] {
  if (!user) {
    return "/auth/login";
  }

  if (user.role === "patient_advocate") {
    return "/task/lookup";
  }

  if (user.permissions.includes("patient_360")) {
    return "/order/lookup";
  }

  if (
    user.permissions.includes("patient_360_analytics") ||
    user.permissions.includes("entity_finance")
  ) {
    return "/patient360-analytics";
  }

  if (user.permissions.includes("pharmacy_360")) {
    return "/suborder/lookup";
  }

  if (user.permissions.includes("practice_360")) {
    return "/bulk-order/lookup";
  }

  if (user.permissions.includes("fulfillment_360")) {
    return "/bulk-suborder/lookup";
  }

  if (user.permissions.includes("sales_360")) {
    return "/commissions/lookup";
  }

  return "/order/lookup";
}
